import React, { FC, useCallback, useMemo } from "react";

import {
  FilterTagsList,
  IRangeFilterData,
  TFilterWithData,
  ThemeProvider,
} from "../../../components";
import {
  desktopTopFilterItemsCheckedGender,
  sortFilterData,
} from "../../../mock/filtersMock";
import { renderFilter } from "../RenderFilterStrategy";
import useFilter from "../useFilter";
import ResponsiveContainer from "../../../components/Utility/ResponsiveContainer/ResponsiveContainer";

const DesktopFiltersTop: FC<any> = ({
  onFiltersChange,
  onClearAll,
  onAnimationEnded,
}) => {
  const allFilters = useMemo(() => {
    return [
      ...desktopTopFilterItemsCheckedGender,
      sortFilterData,
    ] as TFilterWithData[];
  }, []);
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    filterItemsState,
    tags,
    handleClearAll,
    handleFiltersChange,
    handleRemoveFilterTag,
  } = useFilter({ filterItems: allFilters });

  const filtersExceptSorting = useMemo(
    () => filterItemsState.slice(0, filterItemsState.length - 1),
    [filterItemsState],
  );

  const handlePatchedFiltersChange = useCallback(
    (data) => {
      handleFiltersChange(data);
      onFiltersChange && onFiltersChange(data);
    },
    [handleFiltersChange, onFiltersChange],
  );

  const handlePatchedClearAll = useCallback(() => {
    handleClearAll();
    onClearAll && onClearAll();
  }, [handleClearAll, onClearAll]);

  const handleAnimationEnded = useCallback(() => {
    onAnimationEnded && onAnimationEnded();
  }, [onAnimationEnded]);

  return (
    <ThemeProvider theme="dark">
      <div className="filter-top" id="filter-top">
        <div className="filter-top-container">
          <ResponsiveContainer classes={{ root: "filter-top-items" }}>
            {filtersExceptSorting.map((filter: TFilterWithData) =>
              renderFilter({
                filter: {
                  ...filter,
                  variant: "dark",
                  classes: { filterDropdownButton: { button: "mb-4 me-4" } },
                },
                filterType: "dropdown-left",
                onFilterChange: handlePatchedFiltersChange,
              }),
            )}
          </ResponsiveContainer>
        </div>
        <div className="filter-top-sort">
          {renderFilter({
            filter: {
              ...(filterItemsState[
                filterItemsState.length - 1
              ] as IRangeFilterData),
              classes: { filterDropdownButton: { button: "mb-5" } },
              isDisplaySelected: true,
            } as IRangeFilterData,
            filterType: "dropdown-right",
            onFilterChange: handlePatchedFiltersChange,
          })}
        </div>
      </div>
      <FilterTagsList
        filterTags={tags}
        labels={{ clearAll: "Clear All" }}
        onChange={handleRemoveFilterTag}
        onClearAll={handlePatchedClearAll}
        onAnimationEnded={handleAnimationEnded}
      />
    </ThemeProvider>
  );
};

export default DesktopFiltersTop;
